import React, {Component} from 'react';
import moment from 'moment';
import {Card, Divider, Tag} from 'antd';
import {Link} from 'react-router';
import DescriptionList from '@comm/DescriptionList';

import TipsOverdue from '../../comm/TipsOverdue';
import TableFile from '../../comm/TableFile';

const { Description } = DescriptionList;

export default class Back extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleSeatVisible = flag => {};

  handleChange = (uuids, price, disableLen) => {
    this.uuids = uuids;
  };

  render() {
    const { dataInfo } = this.props;
    const businessType = ['在签', '待归档', '已归档'];
    const businessStatus = dataInfo.businessStatus || {};
    const termination = dataInfo.termination || {};
    const title = <TipsOverdue interval={businessStatus.interval} />;
    const extra = <Tag color="#108ee9">{businessType[businessStatus.status]}</Tag>;
    const customLink = (
      <Link to={`/incubator/${dataInfo.incubatorUuid}/custom/detail/${dataInfo.customUuid}`}>
        {dataInfo.custom}
      </Link>
    );
    const businessEndDateElement = dataInfo.endDate
      ? moment.unix(dataInfo.endDate / 1000).format('YYYY-MM-DD')
      : '';
    return (
      <Card title={title} className="mb16" extra={extra}>
        <DescriptionList size="large" col={3}>
          <Description term="公司名称">{customLink}</Description>
          <Description term="项目名称">{dataInfo.projectName}</Description>
          <Description term="孵化器">
            <Link to={`/incubator/one/${dataInfo.incubatorUuid}/detail/bill`}>
              {dataInfo.incubator}
            </Link>
          </Description>
          <Description term="记租时间">
            {dataInfo.beginDate ? moment.unix(dataInfo.beginDate / 1000).format('YYYY-MM-DD') : ''}
          </Description>
          <Description term="到期时间">
            {termination.status === 1 && termination.endDate ? (
              <span>{`${moment
                .unix(termination.beginDate / 1000)
                .format('YYYY-MM-DD')}(原${moment
                .unix(dataInfo.endDate / 1000)
                .format('YYYY-MM-DD')})`}</span>
            ) : (
              businessEndDateElement
            )}
          </Description>
          <Description term="合同金额">{dataInfo.price}</Description>
          <Description term="押金">{dataInfo.indeposit}</Description>
        </DescriptionList>
        <DescriptionList size="large" col={1}>
          <Description term="附件">
            <TableFile dataSource={dataInfo.files || []} disabled />
          </Description>
        </DescriptionList>
        <DescriptionList size="large" col={1}>
          <Description term="备注">{dataInfo.reason}</Description>
        </DescriptionList>
        {termination.status === 1 && termination.endDate ? (
          <div>
            <Divider />
            <DescriptionList size="large" col={1}>
              <Description term="合同终止时间">
                {moment.unix(termination.beginDate / 1000).format('YYYY-MM-DD')}
              </Description>
            </DescriptionList>
            <DescriptionList size="large" col={1}>
              <Description term="附件">
                <TableFile dataSource={termination.files || []} disabled />
              </Description>
            </DescriptionList>
            <DescriptionList size="large" col={1}>
              <Description term="备注">{termination.reason}</Description>
            </DescriptionList>
          </div>
        ) : null}
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/incubator/contract/detail/OtherBase.js